import { Group } from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import { AppBar, Box, IconButton, Toolbar, Tooltip } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import { useAuth } from "@poseidon/ui/components";
import Avatar from "@poseidon/ui/components/Avatar";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

export const DashboardNavbar = (props) => {
  const { app, onSidebarOpen, ...other } = props;
  const theme = useTheme();
  const { profile, loading: profileLoading, error: profileError } = useAuth();
  const themeColor =
    app === "admin" ? theme.palette.secondary : theme.palette.primary;
  const contrastText = themeColor.contrastText;

  const DashboardNavbarRoot = styled(AppBar)(({ theme }) => {
    return {
      backgroundColor: themeColor.main,
      boxShadow: theme.shadows[3],
    };
  });

  return (
    <DashboardNavbarRoot
      sx={{
        left: {
          lg: 280,
        },
        width: {
          lg: "calc(100% - 280px)",
        },
      }}
      {...other}
    >
      <Toolbar
        disableGutters
        sx={{
          minHeight: 64,
          left: 0,
          px: 2,
        }}
      >
        <IconButton
          onClick={onSidebarOpen}
          sx={{
            display: {
              xs: "inline-flex",
              lg: "none",
            },
            color: contrastText,
          }}
        >
          <MenuIcon fontSize="small" />
        </IconButton>
        <Box sx={{ flexGrow: 1 }} />
        {app === "admin" && (
          <Tooltip title="Users">
            <IconButton sx={{ ml: 1 }} component={Link} to="/users">
              <Group fontSize="small" sx={{ color: contrastText }} />
            </IconButton>
          </Tooltip>
        )}
        {/*<Tooltip title="Notifications">*/}
        {/*  <IconButton sx={{ ml: 1 }}>*/}
        {/*    <Badge badgeContent={4} color="primary" variant="dot">*/}
        {/*      <Notifications fontSize="small" sx={{ color: contrastText }} />*/}
        {/*    </Badge>*/}
        {/*  </IconButton>*/}
        {/*</Tooltip>*/}
        <Link to="/profile" style={{ textDecoration: "none" }}>
          <Avatar
            error={profileError}
            loading={profileLoading}
            firstName={profile?.firstName}
            lastName={profile?.lastName}
            size="small"
          ></Avatar>
        </Link>
      </Toolbar>
    </DashboardNavbarRoot>
  );
};

DashboardNavbar.propTypes = {
  onSidebarOpen: PropTypes.func,
};
